module.exports = __webpack_public_path__ + "img/doorLogo9.6c7c124d.png";